; (function (W, $, D, Drupal, drupalSettings) {

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D), filterDeploy = false, bFilterIsSelected = false
  const oUtils = sg.utils


  const _toggleModalFilter = () => {
    const filterContainer = $('.search-filters-container');
    const toggleFilters = $('#toggle-search-filters-modal');
    const closeFilters = filterContainer.find('.close-search-modal');

    toggleFilters.on('click', () => {
      $('html').addClass('overflow-hidden lg:overflow-auto');
      filterContainer.removeClass('translate-x-full');
      filterContainer.addClass('translate-x-0');
    })

    closeFilters.on('click', () => {
      $('html').removeClass('overflow-hidden lg:overflow-auto');
      filterContainer.removeClass('translate-x-0');
      filterContainer.addClass('translate-x-full');
    })
  };

  /**
   * @function _toggleFilter
   * Show/hide Filter form on mobile
   */
  const _toggleFilter = () => {
    $('.form-filter-wrapper .toggle-filters').on('click', (e) => {
      let $btn = $(e.currentTarget),
        target = $btn.attr('aria-controls')

      $('#' + target).slideToggle()
      filterDeploy = !filterDeploy

      let btnLabel = (filterDeploy) ? Drupal.t('Cacher les filtres', {}, { 'context': 'accessibilite' }) : Drupal.t('Afficher les filtres', {}, { 'context': 'accessibilite' })
      oUtils.toggleAriaExpanded($btn)
      $btn.attr('aria-label', btnLabel)
    })
  };

  const _fakeApplyFilter = () => {
    const $form = $('#filters-search');
    const buttonFakeApply = $form.find('.fake-apply-search-filters');
    const filterContainer = $('.search-filters-container');

    $(once('fakeSubmit', buttonFakeApply)).on('click', () => {
      $('html').removeClass('overflow-hidden lg:overflow-auto');
      filterContainer.removeClass('translate-x-0');
      filterContainer.addClass('translate-x-full');
      $form.submit();
    });
  }

  /**
   * @function submitFilterForm
   * Launch custom Ajax Call when user submit form
   */
  const submitFilterForm = () => {
    const $form = $('#filters-search')
    const filterContainer = $('.search-filters-container');
    // recherche?search=commu&type=document&month=2&year=2&page=0
    $(once('submitForm', $form)).on('submit', (e) => {
      e.preventDefault()
      const reset = $form.attr('data-reset') === 'true';
      const baseUrl = [window.location.protocol, '//', window.location.host].join('');
      let url = `${window.location.pathname}?`;
      if (reset === false) {
        let valueSearch = $form.find('input[name="search"]').val();
        let valueType = $form.find('input[name^="types"]:checked').map((index, element) => {
          return `&types[${element.value}]`;
        }).toArray();
        let valueMonth = $form.find('input[name^="months"]:checked').map((index, element) => {
          return `&months[${element.value}]`;
        }).toArray()
        let valueYear = $form.find('input[name^="years"]:checked').map((index, element) => {
          return `&years[${element.value}]`;
        }).toArray()
        if (valueSearch.length > 0) {
          url += `&search=${valueSearch}`;
        }
        if (valueType.length > 0) {
          url += valueType.join('');
        }
        if (valueMonth.length > 0) {
          url += valueMonth.join('');
        }
        if (valueYear.length > 0) {
          url += valueYear.join('');
        }
      }
      $('#filters-search .reset-filter-form').addClass('lg:hidden')
      $('#filters-search .reset-filter-form-mobile').addClass('hidden')
      $('body').after(Drupal.theme.ajaxProgressIndicatorFullscreen())
      $.ajax(url).done((data) => {
        if (typeof data !== 'undefined') {

          let dataGtm = window.localStorage.getItem('data-gtm');
          if (dataGtm) {
            dataGtm = JSON.parse(dataGtm);
            if (dataGtm) {
              if ($(data).find('#noresult').length > 0) {
                dataGtm.ise_page = 0;
              }
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push(dataGtm);
            }
            window.localStorage.removeItem('data-gtm');
          }

          const $container = $('#search-form-results-ajax-wrapper')
          $container.hide()
          $('#search-form-results-ajax-content').replaceWith($(data).find('#search-form-results-ajax-content'))
          $container.fadeIn("slow")
          $('.ajax-progress-fullscreen').remove()

          if (reset === false) {
            //analytics
            sendAnalyticsTags(
              $form.find('input[name="search"]').val(),
              $('#search-form-results-ajax-content .nb-result').attr('data-nb'),
              $form.find('input[name^="years"]:checked').map((index, element) => {
                return $(element).text();
              }).toArray().join(','),
              $form.find('input[name^="months"]:checked').map((index, element) => {
                return $(element).text();
              }).toArray().join(','),
              $form.find('input[name^="years"]:checked').map((index, element) => {
                return $(element).text();
              }).toArray().join(','),
            )
          } else {
            const $allFilter = $('#filters-search select option:selected');
            $allFilter.each((index, element) => {
              element.selected = false;
            });
          }
          $form.removeAttr('data-reset');
          //Set state for prev/back navigation
          window.history.replaceState({}, '', baseUrl + url);
        }
      });
    });
  };

  const resetFilterElements = () => {
    const $allFilter = $('#filters-search select option:selected, #filters-search input[type="checkbox"]:checked');
    $allFilter.each((index, element) => {
      if (element.type === 'checkbox') {
        element.checked = false;
      } else {
        element.selected = false;
      }
    });
  };

  /**
   * @function resetFilter
   * Show/hide reset btn && Set select to default value & submit form
   */
  const resetFilter = () => {
    const $resetFilterBtn = $('#filters-search .reset-filter-form'),
      $resetFilterBtnMobile = $('#filters-search .reset-filter-form-mobile'),
      $textFilter = $('#filters-search input[name="search"]'),
      $form = $('#filters-search'),
      baseUrl = [window.location.protocol, '//', window.location.host, window.location.pathname].join('')

    const updateResetButtonVisibility = () => {
      const $allFilter = $('#filters-search select option:selected, #filters-search input[type="checkbox"]:checked');
      if ($allFilter.length > 0 || $textFilter.val() !== "") {
        $resetFilterBtn.removeClass('lg:hidden');
        $resetFilterBtnMobile.removeClass('hidden');
      } else {
        $resetFilterBtn.addClass('lg:hidden')
        $resetFilterBtnMobile.addClass('hidden')
      }
    };

    updateResetButtonVisibility();
    $(once('ClickReset', '#filters-search .reset-filter-form, #filters-search .reset-filter-form-mobile')).on('click', (e) => {
      e.preventDefault();
      resetFilterElements();
      $textFilter.val('');
      window.history.replaceState({}, '', baseUrl)
      $form.attr('data-reset', true);
      $form.submit();
      updateResetButtonVisibility();
      $('.fake-multiselect').each(function () {
        const fakeMultiSelect = $(this);
        const checkboxes = fakeMultiSelect.find('input[type="checkbox"]');
        const countSpan = fakeMultiSelect.find('.fake-multiselect-count');
        const checkedCount = checkboxes.filter(':checked').length;
        countSpan.text(checkedCount);
        countSpan.removeClass('lg:flex').addClass('lg:hidden');
      });
    });
  };

  /**
   * @function pagerEvent
   * Override pager link to set Ajax call instead of classic link
   */
  const pagerEvent = () => {
    const pager = $('#search-form-results-ajax-wrapper .pager a');
    $(once('pagerClick', pager)).on('click', (e) => {
      e.preventDefault()
      let ajaxUrl = $(e.currentTarget).attr('href')

      $('body').after(Drupal.theme.ajaxProgressIndicatorFullscreen())
      $.ajax(ajaxUrl).done((data) => {
        if (typeof data !== 'undefined') {

          let dataGtm = window.localStorage.getItem('data-gtm');
          if (dataGtm) {
            dataGtm = JSON.parse(dataGtm);
            if (dataGtm) {
              if ($(data).find('#noresult').length > 0) {
                dataGtm.ise_page = 0;
              }
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push(dataGtm);
            }
            window.localStorage.removeItem('data-gtm');
          }

          let $container = $('#search-form-results-ajax-wrapper'),
            baseUrl = [window.location.protocol, '//', window.location.host, window.location.pathname].join('')
          $container.hide()
          $('#search-form-results-ajax-content').replaceWith($(data).find('#search-form-results-ajax-content'))
          $container.fadeIn("slow")
          $('.ajax-progress-fullscreen').remove()

          $('html, body').animate({
            scrollTop: $('#sg-search-search-form').offset().top - (sg.header.getHeight() + 70)
          }, 500);

          //Set state for prev/back navigation
          window.history.replaceState({}, '', baseUrl + ajaxUrl)
        }
      })
    })
  };

  const _submitOnCheckboxesClick = () => {
    const form = $('#filters-search');
    const boxes = form.find('input[type="checkbox"]');

    $(once('submitOnCheckboxesClick', boxes)).on('click', (e) => {
      _countCheckedCheckboxes();
    });
  };

  const _countCheckedCheckboxes = () => {
    const form = $('#filters-search');
    const checkedCount = form.find('input[type="checkbox"]:checked').length;
    const filterCounter = $('#search-filters-number');
    const filterButtonCounter = $('#search-filters-count');
    const noFilterLabel = Drupal.t('No filters', {}, { 'context': 'sg_refonte_old' });
    const oneFilterLabel = checkedCount + ' ' + Drupal.t('filter', {}, { 'context': 'sg_refonte_old' });
    const moreFilterLabel = checkedCount + ' ' + Drupal.t('filters', {}, { 'context': 'sg_refonte_old' });
    filterButtonCounter.text(checkedCount);

    if (checkedCount < 1) {
      filterCounter.text(noFilterLabel);
      filterButtonCounter.addClass('opacity-0');
    }
    else if (checkedCount == 1) {
      filterCounter.text(oneFilterLabel);
      filterButtonCounter.removeClass('opacity-0');
    }
    else {
      filterCounter.text(moreFilterLabel);
      filterButtonCounter.removeClass('opacity-0');
    }
  };

  const sendAnalyticsTags = (keyword, nbresult = 0, ind3 = '', ind4 = '', ind5 = '') => {
    let n2 = drupalSettings.langcode === 'en' ? '::header_search::search_results' : '::recherche_header::resultats_recherche'
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'pageview',
        id_composant: 'browser_results',
        event_name: window.dataLayer[0].domain + n2,
        ind_page_1: oUtils.slugifyTag(keyword),
        ind_page_2: nbresult,
        ind_page_3: oUtils.slugifyTag(ind3),
        ind_page_4: oUtils.slugifyTag(ind4),
        ind_page_5: oUtils.slugifyTag(ind5),
      })
    }
  };

  const init = () => {
    _toggleFilter()
    submitFilterForm()
    resetFilter()
    pagerEvent()
    _submitOnCheckboxesClick()
    _countCheckedCheckboxes()
  }
    ;
  $D.ready(function () {
    init();
    //Open header searchBar on dom ready
    if (sg.viewport.isMobile() || sg.viewport.isPortrait()) {
      $('#header .header-search-button.mobile').click()
    } else {
      $('#header .header-search-button.desktop-only').click()
    }
    sendAnalyticsTags(
      window.sessionStorage.getItem('searchFormValue'),
      $('#search-form-results-ajax-content .nb-result').attr('data-nb'),
      $('#filters-search').find('input[name^="types"]:checked').map((index, element) => {
        return $(element).text();
      }).toArray().join(','),
      $('#filters-search').find('input[name^="months"]:checked').map((index, element) => {
        return $(element).text();
      }).toArray().join(','),
      $('#filters-search').find('input[name^="years"]:checked').map((index, element) => {
        return $(element).text();
      }).toArray().join(','),
    )

  }).on('sg:viewport.resize-end', function () {
    if (!sg.viewport.isMobile()) {
      $('.form-filter-wrapper #filters-search').show()
    }
  }).ajaxSuccess(function () {
    init();
    _toggleModalFilter();
    _fakeApplyFilter();
  })

})(window, window.jQuery, document, window.Drupal, window.drupalSettings, once)
